import SocketService from '@src/services/SocketService';

import { EMagicPenSockets, EMagicPenActionType } from '@src/types';

/* 
This service is used to clear Magic Pen annotations.
It emits a socket request to clear all annotations or only the current user's annotations.
*/

export const clearAllAnnotations = async (clearOnlyMine: boolean): Promise<void> => {
  try {
    await SocketService.request(EMagicPenSockets.MAGIC_PEN, {
      actionType: EMagicPenActionType.CLEAR_ALL_ANNOTATION,
      clearOnlyMine,
    });
  } catch (error) {
    console.error('Error emitting MagicPen clearAllAnnotation action:', error);
  }
};
